import { ExerciseOptions } from "@/common/constants";
import { formatDistanceScaled } from "@/common/common";
export const objectToUserProfile = (item) => {
    return {
        id: +item.id,
        activeMissionId: +item.active_mission_id,
        backgroundImage: item.background_image,
        countryCode: item.country_code === "" ? "ZZ" : item.country_code,
        distanceUnit: item.distance_unit,
        firstName: item.first_name,
        fullName: item.full_name,
        image: item.image,
        lastName: item.last_name,
        stats: {
            activeMissions: +item.stats.active_missions,
            completedMissions: +item.stats.completed_missions,
            distanceMonth: formatDistanceScaled(item.stats.distance_month),
            distanceTotal: formatDistanceScaled(item.stats.distance_total),
            distanceYear: formatDistanceScaled(item.stats.distance_year),
            totalMissions: +item.stats.total_missions,
            totalDistances: {
                actualDistanceTotalPostUserLogId: item.stats.total_distance.actual_distance_total_post_user_log_id,
                virtualDistanceTotalPreUserLogId: item.stats.total_distance.virtual_distance_total_pre_user_log_id,
            }
        },
    };
};
export const collectionToUserProfileActivities = (activities) => {
    return activities.activity_statistics.map((item) => {
        return {
            distanceMonth: formatDistanceScaled(item.distance_month),
            distancePct: +item.distance_pct,
            distanceTotal: formatDistanceScaled(item.distance_total),
            distanceUnit: item.distance_unit,
            distanceYear: formatDistanceScaled(item.distance_year),
            exerciseType: convertExerciseTypeAliasToName(item.exercise_type),
            exerciseTypeAlias: item.exercise_type,
            exerciseTypeId: +item.exercise_type_id,
            totalDistance: formatDistanceScaled(item.total_distance),
            totalDistanceKm: item.total_distance_km,
        };
    });
};
export const collectionToUserProfileMissions = (missions) => {
    return missions.missions.map((item) => {
        return {
            id: +item.id,
            color1: item.color_1,
            color2: item.color_2,
            color3: item.color_3,
            completed: item.completed,
            name: item.name,
            slug: item.slug,
            missionGoal: +item.mission_goal,
            distanceUnit: item.distance_unit,
            distanceGoal: item.distance_target,
            distancePct: +item.distance_pct,
            imgBackground: item.img_bg,
            imgAvatar: item.img_avatar,
            timePct: +item.time_pct,
            groupName: item.group_name ?? "",
            isAdmin: item.is_admin ?? false,
            isFundraising: typeof item.fundraising_target === "string" &&
                +item.fundraising_target > 0,
            exerciseTypes: item.exercise_types.map((type) => type.alias2),
            participantsCt: item.participants_ct,
            isConqueror: item.is_conqueror,
            startDate: item.timeframe.mission_time,
            type: item.type,
            isCompleted: item.completed,
            categoryId: item.category_id,
        };
    });
};
export const convertExerciseTypeAliasToName = (alias) => {
    return ExerciseOptions[alias];
};
